// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feeStructureFormMainArea":"nBtu1utqU3xTaP7A8tec_","feeStructureFormColumn":"_26t2ED-y7468nGlTFypU5x"};